// extracted by mini-css-extract-plugin
export default {"amount-per-serving":"SimplePDPModal-module__amount-per-serving__uaLmD","pdp-modal":"SimplePDPModal-module__pdp-modal__dSjSW"};